<template>
    <div>
        <header-portrate />
        <div style="margin-bottom:70px;">
            <tabs-comp :tabs="tabs" />
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:100px !important;border:1px solid #555;border-radius:10px;padding-bottom:10px;`">
                <v-col cols="12" md="3" sm="12">
                    <label>{{lang.status}}</label>
                    <b-form-select class="inborder" v-model="filters.status" :options="statusOptions" />
                </v-col>
                <v-col cols="12" md="3" sm="12">
                    <label>{{lang.event_type || 'Event'}}</label>
                    <b-form-select class="inborder" v-model="filters.event_type" :options="eventOptions" />
                </v-col>
                <v-col cols="12" md="3" sm="12">
                    <label>{{lang.mobile}}</label>
                    <b-form-input class="inborder" v-model="filters.phone" @keyup.enter="getLogs()" />
                </v-col>
                <v-col cols="12" md="3" sm="12" style="align-self:flex-end;">
                    <b-button variant="light" style="background:blue;color:#fff;width:100%;" @click="getLogs()">{{lang.search}}</b-button>
                </v-col>
            </v-row>
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;`">
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="rows"
                        :items-per-page="-1"
                        class="elevation-1"
                        hide-default-footer
                        fixed-header
                        :loading="loading"
                    >
                        <template v-slot:item="row">
                            <tr>
                                <td style="text-align:center;width:60px;">{{ row.item.id }}</td>
                                <td style="text-align:center;">{{ eventLabel(row.item.event_type) }}</td>
                                <td style="text-align:center;direction:ltr;">{{ row.item.phone }}</td>
                                <td style="max-width:340px;white-space:normal;">{{ row.item.message }}</td>
                                <td style="text-align:center;">
                                    <span :style="statusStyle(row.item.status)">{{ statusLabel(row.item.status) }}</span>
                                </td>
                                <td style="text-align:center;">{{ row.item.attempts }}</td>
                                <td style="text-align:center;white-space:nowrap;">{{ row.item.created_at }}</td>
                                <td style="text-align:center;white-space:nowrap;">{{ row.item.sent_at || '-' }}</td>
                                <td style="text-align:center;color:#c0392b;max-width:220px;white-space:normal;">{{ row.item.last_error || '' }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import TabsComp from '@/components/tabsComp.vue'
import axios from 'axios'
export default{
    components: {
        HeaderPortrate, Footer,
        TabsComp,
    },
    data() {
        return {
            rows: [],
            loading: false,
            filters: {
                status: '',
                event_type: '',
                phone: '',
            },
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        statusOptions: function(){
            return [
                { value: '', text: this.lang.all || 'الكل' },
                { value: 'pending', text: this.lang.pending || 'قيد الانتظار' },
                { value: 'sent', text: this.lang.sent || 'تم الإرسال' },
                { value: 'delivered', text: this.lang.delivered || 'تم التسليم' },
                { value: 'read', text: this.lang.read || 'تمت القراءة' },
                { value: 'failed', text: this.lang.failed || 'فشل' },
            ]
        },
        eventOptions: function(){
            return [
                { value: '', text: this.lang.all || 'الكل' },
                { value: 'new_invoice', text: 'فاتورة جديدة' },
                { value: 'new_quotation', text: 'عرض سعر جديد' },
                { value: 'new_customer', text: 'عميل جديد' },
                { value: 'new_card', text: 'أمر عمل جديد' },
                { value: 'card_ready', text: 'جاهز للتسليم' },
                { value: 'card_closed', text: 'أمر عمل مغلق' },
                { value: 'update_card', text: 'تحديث أمر عمل' },
                { value: 'invoice_followup', text: 'متابعة فاتورة' },
                { value: 'oil_change_followup', text: 'متابعة تغيير زيت' },
            ]
        },
        headers: function(){
            return [
                { text: '#', value: 'id' },
                { text: this.lang.event_type || 'الحدث', value: 'event_type' },
                { text: this.lang.mobile, value: 'phone' },
                { text: this.lang.message || 'الرسالة', value: 'message' },
                { text: this.lang.status, value: 'status' },
                { text: this.lang.attempts || 'المحاولات', value: 'attempts' },
                { text: this.lang.created_date || 'تاريخ الإنشاء', value: 'created_at' },
                { text: this.lang.sent_date || 'تاريخ الإرسال', value: 'sent_at' },
                { text: this.lang.error || 'الخطأ', value: 'last_error' },
            ]
        },
        tabs: function(){

            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                      if(alicense[value.perms[0]] || value.perms[0] == 'any')
                          t.push(value)
                    }
                }
            })

            return t;
        },
    },
    methods: {
        eventLabel(eventType){
            const found = this.eventOptions.find(o => o.value === eventType);
            return found ? found.text : eventType;
        },
        statusLabel(status){
            const found = this.statusOptions.find(o => o.value === status);
            return found ? found.text : status;
        },
        statusStyle(status){
            const colors = {
                pending: '#888',
                sent: '#1a73e8',
                delivered: '#0a8a3f',
                read: '#0a8a3f',
                failed: '#c0392b',
            };
            return `color:#fff;background:${colors[status] || '#888'};padding:3px 10px;border-radius:12px;font-size:0.85rem;white-space:nowrap;`;
        },
        async getLogs(){
            this.loading = true;
            const post = new FormData();
            post.append("type","getWahaOutboxLog");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[limit]", 100);
            if(this.filters.status) post.append("data[status]", this.filters.status);
            if(this.filters.event_type) post.append("data[event_type]", this.filters.event_type);
            if(this.filters.phone) post.append("data[phone]", this.filters.phone);
            try{
                const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post)
                if(response && response.data && response.data.results){
                    this.rows = response.data.results.data || [];
                }
            } finally {
                this.loading = false;
            }
        },
    },
    created(){
        this.getLogs()
    }

}
</script>
